import { motion } from "framer-motion";

import { CreateTokenWizard } from "../components/creation/CreateTokenWizard";
import { ConnectPrompt } from "../components/wallet/ConnectPrompt";
import { useRequireAuth } from "../hooks/use-require-auth";
import { fadeInUp } from "../lib/animations";

export function CreateTokenPage() {
	const { isAuthenticated } = useRequireAuth();

	if (!isAuthenticated) {
		return (
			<motion.div
				variants={fadeInUp}
				initial="hidden"
				animate="visible"
				className="mx-auto max-w-4xl px-4 py-16 text-center"
			>
				<h1 className="text-3xl font-bold text-pastel-black mb-4">Launch Your Token</h1>
				<div className="flex justify-center">
					<ConnectPrompt message="Connect your wallet to launch a token" />
				</div>
			</motion.div>
		);
	}

	return (
		<motion.div variants={fadeInUp} initial="hidden" animate="visible">
			<div className="mx-auto max-w-4xl px-4 py-8 text-center mb-8">
				<h1 className="text-3xl font-bold text-pastel-black mb-2">Launch Your Token</h1>
				<p className="text-pastel-gray">
					Create and deploy your token on Uniswap V4 in just a few steps.
				</p>
			</div>
			<CreateTokenWizard />
		</motion.div>
	);
}
